import React from 'react';
import buttonClose from "../../../assets/images/shared/modals/button-close.svg";

const DeleteData = ({ 
  showModalDeleteData, 
  closeModalDeleteData, 
  product, brand, 
  codbalanza, 
  context, confirmDelete, 
  categoryName, // Agregamos categoryName como prop
  productName,
}) => {
  if (!showModalDeleteData) return null; // No renderiza si el modal no está activo

  const message =
    context === "Balanza"
      ? `¿Está seguro que desea eliminar la balanza con código ${codbalanza}?`
      : context === "Productos"
      ? `¿Está seguro que desea eliminar el producto ${product}?`
    : context === "MarcaBalanzas"
    ? `¿Está seguro que desea eliminar la marca de balanza ${brand}?`
    : context === "Categorías"
    ? `¿Está seguro que desea eliminar la categoría con ID ${categoryName}?`
    : context === "Producto"
    ? `¿Está seguro que desea eliminar el producto ${productName}?`

      : "¿Está seguro que desea realizar esta acción?"; // Mensaje por defecto
    

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="flex flex-col max-w-[350px] h-auto p-5 bg-white shadow-lg rounded-3xl ">
        <div className='flex justify-end '>
          <button
            onClick={closeModalDeleteData}
            className="rounded-md"
          >
            <img src={buttonClose} alt="Cerrar" />
          </button>
        </div>
        <div className='flex flex-col items-center justify-center gap-2 p-5'>
          <p className="text-[#007696] text-[16px] text-center font-itcdemi">
            {message}
          </p>
          <p className='text-gray text-[12px] font-itcbook text-center'>Una vez eliminado el registro no se podrá recuperar.</p>

          <button onClick={confirmDelete} className='bg-green mt-8 text-white font-itcdemi text-lg rounded-[8px] w-[189px] h-[39.02px] flex items-center justify-center'>Eliminar</button>
        </div>
          
        </div>
      </div>
  );
};

export default DeleteData;
